module.exports = __webpack_public_path__ + "static/media/jira_transparent.89e8531b.png";